import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Codepen = createReactComponent("Codepen", ["svg", defaultAttributes, [["polygon", {
  points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2",
  key: "1512qd"
}], ["line", {
  x1: "12",
  y1: "22",
  x2: "12",
  y2: "15.5",
  key: "hz0be7"
}], ["polyline", {
  points: "22 8.5 12 15.5 2 8.5",
  key: "ta10jh"
}], ["polyline", {
  points: "2 15.5 12 8.5 22 15.5",
  key: "1rwkas"
}], ["line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "8.5",
  key: "1y8rn7"
}]]]);
export default Codepen;